import { createElementBlock, openBlock, createVNode, unref, withCtx, renderSlot } from "vue";
import { DtToggle } from "@dialpad/dialtone-vue";
import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
/* empty css                     */
const _hoisted_1 = { class: "dtc-control-boolean" };
const __default__ = {
  name: "DtcControlBoolean"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    value: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: [VALUE_UPDATE_EVENT],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(unref(DtToggle), {
          value: __props.value,
          disabled: __props.disabled,
          "label-class": "d-label--sm d-fc-secondary",
          size: "sm",
          "wrapper-class": "d-jc-space-between",
          "data-qa": "dtc-control-boolean-input",
          onChange: _cache[0] || (_cache[0] = (e) => emit(unref(VALUE_UPDATE_EVENT), e))
        }, {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["value", "disabled"])
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=control_boolean.vue.js.map
